import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withModifiers as _withModifiers } from "vue"

export function render(_ctx, _cache) {
  const _component_FormHeader = _resolveComponent("FormHeader")
  const _component_FormItems = _resolveComponent("FormItems")
  const _component_FormFooter = _resolveComponent("FormFooter")

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("form", {
      class: _normalizeClass(_ctx.getClass('form-inline')),
      onSubmit: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.getClass('form-container'))
      }, [
        _createCommentVNode(" Render Form Header "),
        (_ctx.shouldShowFormHeader)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(_ctx.getClass('form-header'))
            }, [
              _createVNode(_component_FormHeader, {
                components: _ctx.component.formHeader
              }, null, 8 /* PROPS */, ["components"])
            ], 2 /* CLASS */))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" Render Form Items "),
        (_ctx.shouldShowFormItems)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass(_ctx.getClass('form-items'))
            }, [
              _createVNode(_component_FormItems, {
                components: _ctx.component.formItems,
                messageId: _ctx.messageId
              }, null, 8 /* PROPS */, ["components", "messageId"])
            ], 2 /* CLASS */))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" Render Form Footer "),
        (_ctx.shouldShowFormFooter)
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: _normalizeClass(_ctx.getClass('form-footers'))
            }, [
              _createVNode(_component_FormFooter, {
                components: _ctx.component.formFooter,
                formValid: _ctx.formValid
              }, null, 8 /* PROPS */, ["components", "formValid"])
            ], 2 /* CLASS */))
          : _createCommentVNode("v-if", true)
      ], 2 /* CLASS */)
    ], 34 /* CLASS, NEED_HYDRATION */)
  ]))
}